export default "__VITE_ASSET__C00B2N2l__"